export const dataMappingTour = {
    module: 'data_mapping',
    title: 'Data Mapping Tour',
    title_vi: 'Tour Bản đồ dữ liệu',
    description: 'As the Data Steward (P-VN-05), build your ROPA inventory, map cross-border data flows, and maintain the processing activity register required by PDPL.',
    description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Data Steward (P-VN-05), build your ROPA inventory, map cross-border data flows, and maintain the processing activity register required by PDPL.',",
    estimated_duration_seconds: 48,
    steps: [
        {
            step_id: 'open_data_mapping',
            navigate_to: '/admin/data-mapping/systems',
            target: '.dm-page',
            title: 'Data Mapping Module',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Data Mapping Module',
            description: "As the Data Steward, you maintain the organization's personal data inventory here. PDPL requires a complete record of processing activities (ROPA) and cross-border transfer documentation.",
            position: 'bottom',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: "As the Data Steward, you maintain the organization\'s personal data inventory here. PDPL requires a complete record of processing activities (ROPA) and cross-border transfer documentation.", position: \'bottom',
            delay_ms: 600,
        },
        {
            step_id: 'systems_list',
            target: '.dm-table',
            title: 'Systems Inventory',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Systems Inventory',
            description: 'Every system processing personal data must be registered here with its data categories and legal basis. This inventory feeds directly into your ROPA and DPIA assessments.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Every system processing personal data must be registered here with its data categories and legal basis. This inventory feeds directly into your ROPA and DPIA assessments.',
            position: 'bottom',
        },
        {
            step_id: 'create_system',
            target: '.dm-header .btn-primary',
            title: 'Add a New System',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Add a New System',
            description: 'Register each application or service that processes personal data. Unregistered systems create ROPA gaps flagged during audits.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Register each application or service that processes personal data. Unregistered systems create ROPA gaps flagged during audits.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 100,
        },
        {
            step_id: 'fill_system_name',
            target: '[data-testid="system-name"]',
            title: 'Enter System Name',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enter System Name',
            description: 'Use the official application or service name as it appears in your IT asset register for cross-referencing during audits.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Use the official application or service name as it appears in your IT asset register for cross-referencing during audits.',
            position: 'bottom',
            wait_for: '[data-testid="system-name"]',
            action: { type: 'fill', target: '[data-testid="system-name"]', value: '[TOUR] CRM Platform' },
        },
        {
            step_id: 'fill_system_owner',
            target: '#system-owner',
            title: 'Enter System Owner',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enter System Owner',
            description: 'Assign the accountable person or team. PDPL requires clear data controller/processor accountability for every processing system.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Assign the accountable person or team. PDPL requires clear data controller/processor accountability for every processing system.',
            position: 'bottom',
            action: { type: 'fill', target: '#system-owner', value: '[TOUR] Privacy Team' },
        },
        {
            step_id: 'fill_system_type',
            target: '[data-testid="system-type"]',
            title: 'Select System Type',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select System Type',
            description: 'Classify the system type. Cloud SaaS and third-party processors may trigger cross-border transfer assessments under PDPL.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Classify the system type. Cloud SaaS and third-party processors may trigger cross-border transfer assessments under PDPL.',
            position: 'bottom',
            action: { type: 'select', target: '[data-testid="system-type"]', value: 'cloud_saas' },
        },
        {
            step_id: 'fill_system_status',
            target: '#system-status',
            title: 'Select System Status',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select System Status',
            description: 'Track the system lifecycle. Decommissioning systems must have their data retention and deletion obligations fulfilled before removal from the register.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Track the system lifecycle. Decommissioning systems must have their data retention and deletion obligations fulfilled before removal from the register.',
            position: 'bottom',
            action: { type: 'select', target: '#system-status', value: 'active' },
        },
        {
            step_id: 'submit_system',
            target: '.dm-form-actions button[type="submit"]',
            title: 'Save the System',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save the System',
            description: 'Register the system in your data map. It will automatically appear in ROPA gap analysis and be available for DPIA linking.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Register the system in your data map. It will automatically appear in ROPA gap analysis and be available for DPIA linking.',
            position: 'top',
        },
        {
            step_id: 'navigate_categories',
            navigate_to: '/admin/data-mapping/categories',
            target: '.dm-page',
            title: 'Data Categories',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Data Categories',
            description: 'Define personal data categories your organization processes. PDPL distinguishes sensitive personal data (health, biometrics, political opinions) which requires explicit consent.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define personal data categories your organization processes. PDPL distinguishes sensitive personal data (health, biometrics, political opinions) which requires explicit consent.',
            position: 'bottom',
        },
        {
            step_id: 'navigate_flows',
            navigate_to: '/admin/data-mapping/flows',
            target: '.dm-page',
            title: 'Data Flows',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Data Flows',
            description: 'Map how personal data moves between systems. Cross-border flows outside Vietnam require transfer impact assessments and adequate safeguards under PDPL.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Map how personal data moves between systems. Cross-border flows outside Vietnam require transfer impact assessments and adequate safeguards under PDPL.',
            position: 'bottom',
        },
        {
            step_id: 'flows_table',
            target: '.dm-table',
            title: 'Flow Registry',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Flow Registry',
            description: 'All documented data transfers with legal basis and safeguards. This registry is the foundation for Decree 13 cross-border transfer compliance.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: All documented data transfers with legal basis and safeguards. This registry is the foundation for Decree 13 cross-border transfer compliance.',
            position: 'bottom',
        },
        {
            step_id: 'navigate_activities',
            navigate_to: '/admin/data-mapping/activities',
            target: '.dm-page',
            title: 'Processing Activities (ROPA)',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Processing Activities (ROPA)',
            description: 'Document your Records of Processing Activities as required by PDPL. Each activity must record its purpose, legal basis, data subjects, and retention period.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Document your Records of Processing Activities as required by PDPL. Each activity must record its purpose, legal basis, data subjects, and retention period.',
            position: 'bottom',
        },
        {
            step_id: 'activities_table',
            target: '.dm-table',
            title: 'Activities Register',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Activities Register',
            description: 'The ROPA register links each processing activity to its controller, legal basis, data subjects, and retention schedule. This is a primary audit artifact for PDP Committee inspections.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: The ROPA register links each processing activity to its controller, legal basis, data subjects, and retention schedule. This is a primary audit artifact for PDP Committee inspections.',
            position: 'bottom',
        },
        {
            step_id: 'export_data',
            target: '.dm-header .btn-secondary',
            title: 'Export Data Map',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Export Data Map',
            description: 'Export the complete data inventory as CSV or PDF. This produces an audit-grade ROPA dossier package suitable for PDP Committee submissions and internal governance reviews.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Export the complete data inventory as CSV or PDF. This produces an audit-grade ROPA dossier package suitable for PDP Committee submissions and internal governance reviews.',
            position: 'bottom',
        },
        {
            step_id: 'data_mapping_complete',
            target: '.dm-page',
            title: 'Data Mapping Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Data Mapping Tour Complete',
            description: 'You can now maintain a complete PDPL-compliant data inventory: systems, categories, cross-border flows, and ROPA entries with full export capability for regulatory submissions.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now maintain a complete PDPL-compliant data inventory: systems, categories, cross-border flows, and ROPA entries with full export capability for regulatory submissions.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=data-mapping.js.map